module.exports = __webpack_public_path__ + "images/waww-logo-e8041661f7d3163ca23d6a0ae97cbbc0.svg";